// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__KcMqZ","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__2y-Ix"};